import React from 'react';
import CensorBar from './CensorBar';

const SIZE_TO_HEADLINE_STYLE = {
  L: { fontSize: '64px', lineHeight: 1.05 },
  M: { fontSize: '40px', lineHeight: 1.1 },
  S: { fontSize: '28px', lineHeight: 1.2 },
};

const SUBTITLE_STYLE = {
  fontSize: '11px',
  letterSpacing: '0.10em',
};

const EditorialBlock = ({
  headline,
  subtitle,
  metric,
  size = 'M',
  as: Heading = 'h2',
  className = '',
}) => {
  const headlineStyle = SIZE_TO_HEADLINE_STYLE[size] || SIZE_TO_HEADLINE_STYLE.M;
  return (
    <div className={`flex flex-col gap-4 ${className}`.trim()}>
      <Heading
        className="font-display m-0"
        style={headlineStyle}
        data-size={size}
      >
        {headline}
      </Heading>
      {subtitle && (
        <p
          className="font-display uppercase m-0"
          style={SUBTITLE_STYLE}
        >
          {subtitle}
        </p>
      )}
      {metric && (
        <div>
          <CensorBar mode={metric.mode} value={metric.value} size="md" />
        </div>
      )}
    </div>
  );
};

export default EditorialBlock;
